import { IDateFinderDescription } from 'redhotpie-shared-lib/interfaces/IDateFinder';

// eslint-disable-next-line react/require-extension
export default class DateFinderDescription {
  id: number;
  name: string;
  listId: number;

  constructor() {
    this.id = 0;
    this.name = '';
    this.listId = 0;
  }

  static mappingPropertyObject(object: any): IDateFinderDescription {
    const newObject = new DateFinderDescription();
    newObject.id = object.ItemID || 0;
    newObject.name = object.ItemName || '';
    newObject.listId = object.ListID || 0;

    return newObject;
  }

  static mappingPropertyObjects(_objects: any): IDateFinderDescription[] {
    const results: IDateFinderDescription[] = [];
    _objects.forEach((_des: any) => {
      const des = DateFinderDescription.mappingPropertyObject(_des);
      results.push(des);
    });
    return results;
  }
}
